/** Base path for the institution dashboard shell. */
export const DASHBOARD_BASE = "/dashboard";

/**
 * Canonical dashboard route segments (camelCase for multi-word modules).
 * Used by react-router child paths and navigation links.
 */
export const DASHBOARD_PATHS = {
  mapOverview: "mapOverview",
  dispatchBoard: "dispatchBoard",
  scheduling: "scheduling",
  studentSchedules: "studentSchedules",
  vehicles: "vehicles",
  drivers: "drivers",
  stops: "stops",
  trips: "trips",
  administrators: "administrators",
  familyManagement: "familyManagement",
  notifications: "notifications",
  auditLogs: "auditLogs",
  serviceAnnouncement: "serviceAnnouncement",
  busPolicy: "busPolicy",
  generalPolicy: "generalPolicy",
  externalApps: "externalApps",
};

/** Build a full dashboard URL from a route segment. */
export const dashboardPath = (segment) =>
  `${DASHBOARD_BASE}/${segment}`;

/**
 * Legacy lowercase paths → canonical segments.
 * Kept for bookmarks and shared links; registered as redirects in routes.jsx.
 */
export const LEGACY_DASHBOARD_REDIRECTS = {
  studentschedules: DASHBOARD_PATHS.studentSchedules,
  familymanagement: DASHBOARD_PATHS.familyManagement,
  serviceannouncement: DASHBOARD_PATHS.serviceAnnouncement,
  buspolicy: DASHBOARD_PATHS.busPolicy,
  generalpolicy: DASHBOARD_PATHS.generalPolicy,
  externalapps: DASHBOARD_PATHS.externalApps,
  auditlogs: DASHBOARD_PATHS.auditLogs,
};

/** Returns true when pathname matches a dashboard route (canonical or legacy). */
export const isDashboardRoute = (pathname, segment) => {
  const canonical = dashboardPath(segment);
  if (pathname === canonical) return true;
  const legacyKey = Object.keys(LEGACY_DASHBOARD_REDIRECTS).find(
    (key) => LEGACY_DASHBOARD_REDIRECTS[key] === segment
  );
  return legacyKey ? pathname === dashboardPath(legacyKey) : false;
};
